module.exports = __webpack_public_path__ + "img/export.27150ddc.svg";